import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { getContentBlock } from '../../slices/content-block-slice';

export const CookiePolicy = () => {
  const dispatch = useAppDispatch();
  const { contentBlock, loading } = useAppSelector(
    (state) => state.contentBlock
  );

  useEffect(() => {
    dispatch(getContentBlock({ contentBlockId: 150, languageId: 1 }));
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <Spinner fullScreen={true} />
      ) : (
        <div style={{ maxWidth: '800px', margin: '50px auto 0 auto' }}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentBlock && contentBlock.content
            }}
          />
        </div>
      )}
    </>
  );
};
